import { render, staticRenderFns } from "./incomeDetail.vue?vue&type=template&id=9ddfe5c8&scoped=true&"
import script from "./incomeDetail.vue?vue&type=script&lang=js&"
export * from "./incomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./incomeDetail.vue?vue&type=style&index=0&id=9ddfe5c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddfe5c8",
  null
  
)

export default component.exports